/* eslint-disable */
import { gridBreakpoints, columns, gutterWidth } from './settings';
var containerMaxWidths = {};
/**
 * Generate semantic grid columns with these functions.
 */

export var makeMainContainer = function makeMainContainer(_ref) {
  var noGutter = _ref.noGutter,
      theme = _ref.theme;
  return "width: 100%;\n          padding-right: ".concat(noGutter ? 0 : '16px', ";\n          padding-left: ").concat(noGutter ? 0 : '16px', ";\n          margin-right: auto;\n          margin-left: auto;\n\n          @media (min-width: ").concat(theme.screen.mdMin, "){\n            padding-right: ").concat(noGutter ? 0 : '36px', ";\n            padding-left: ").concat(noGutter ? 0 : '36px', ";\n          }\n          \n          @media (min-width: ").concat(theme.screen.lgMin, "){\n            padding-right: ").concat(noGutter ? 0 : '20px', ";\n            padding-left: ").concat(noGutter ? 0 : '20px', ";\n          }\n          \n          @media (min-width: ").concat(theme.screen.xlMin, "){\n            max-width: ").concat(theme.grid.containerMaxWidths.xl, ";\n            padding-right: ").concat(noGutter ? 0 : '24px', ";\n            padding-left: ").concat(noGutter ? 0 : '24px', ";\n          }");
};
export var makeContainer = function makeContainer(_ref2) {
  var noGutter = _ref2.noGutter,
      gutter = _ref2.gutter;
  var padding = noGutter ? 0 : (gutter || gutterWidth) / 2;
  return "width: 100%;\n          padding-right: ".concat(padding, "px;\n          padding-left: ").concat(padding, "px;\n          margin-right: auto;\n          margin-left: auto;");
};
export var makeContainerMaxWidth = Object.keys(containerMaxWidths).map(function (breakpoint) {
  return "\n    @media ( min-width: ".concat(gridBreakpoints[breakpoint], "px ) {\n      max-width: ").concat(containerMaxWidths[breakpoint], ";\n    }\n  ");
});
/**
 * For each breakpoint, define the maximum width of the container in a media query
 */

export var makeRow = function makeRow(_ref3) {
  var noGutter = _ref3.noGutter,
      gutter = _ref3.gutter;
  var margin = noGutter ? 0 : -(gutter || gutterWidth) / 2;
  return "display: flex;\n          flex-wrap: wrap;\n          margin-right: ".concat(margin, "px;\n          margin-left: ").concat(margin, "px;");
};
/**
 * Prevent columns from becoming too narrow when at smaller grid tiers by
 * always setting width: 100%;. This works because we use flex values
 * later on to override this initial width.
 *
 * Add a `max-width` to ensure content within each column does not blow out
 * the width of the column. Applies to IE10+ and Firefox. Chrome and Safari
 * do not appear to require this.
 *
 *  props:
 *
 *  [breackpoint] = {[int]}
 *
 *  [breackpoint] = {
 *     size: [int],
 *     order: [int],
 *     offset: [int]
 *  }
 */

var makeColBreackpoint = function makeColBreackpoint(props, breakpoint) {
  var size = typeof props[breakpoint] === 'object' ? props[breakpoint].size : props[breakpoint];
  var order = props[breakpoint].order ? props[breakpoint].order : null;
  return "@media ( min-width: ".concat(gridBreakpoints[breakpoint], "px ) {\n            -ms-flex: 0 0 ").concat(size ? size * 100 / columns : 100, "%;\n            flex: 0 0 ").concat(size ? size * 100 / columns : 100, "%;\n            max-width: ").concat(size ? size * 100 / columns : 100, "%;\n            order: ").concat(order != null ? "".concat(order) : '', ";\n          }");
};

var makeSimpleCol = function makeSimpleCol() {
  return "-ms-flex-preferred-size: 0;\n          flex-basis: 0;\n          -ms-flex-positive: 1;\n          flex-grow: 1;\n          max-width: 100%;";
};

var makeColOffset = function makeColOffset(offset, breakpoint) {
  var size = breakpoint;
  return "@media ( min-width: ".concat(gridBreakpoints[breakpoint], "px ) {\n            margin-left: ").concat(offset * 100 / columns, "%;\n          }");
};

export var makeCol = function makeCol(props) {
  var noGutter = props.noGutter,
      offsets = props.offset,
      theme = props.theme,
      gutter = props.gutter;
  containerMaxWidths = theme.grid.containerMaxWidths;
  var padding = noGutter ? 0 : (gutter || gutterWidth) / 2;
  var styles = "position: relative;\n                width: 100%;\n                padding-right: ".concat(padding, "px;\n                padding-left: ").concat(padding, "px;\n                scroll-behavior: smooth;");
  var hasBreakpoints = false;
  /**
   *  Chequeamos si en los props que recibimos contamos con algún breckpoint
   *  Esperamos recibir xs, sm, md, lg, xl
   */

  Object.keys(gridBreakpoints).map(function (breakpoint) {
    if (!hasBreakpoints) {
      hasBreakpoints = props.hasOwnProperty(breakpoint);
    }
  });
  /**
   * Si contamos con offset creamos los media queries para aplicarlos
   * el offset esta conformado por:
   * - El breakpoint donde se aplica, será la key del object
   * - Tamaño del offset, que será el value del object
   *
   * offset = {{xs: 2, lg: 4}}
   */

  if (offsets) {
    Object.keys(gridBreakpoints).map(function (breakpoint) {
      Object.keys(offsets).map(function (offset) {
        if (offset == breakpoint) {
          styles += makeColOffset(offsets[offset], breakpoint);
        }
      });
    });
  }
  /**
   *  Si hay breackpoints creamos la columna configurando cada uno
   */


  if (hasBreakpoints) {
    Object.keys(gridBreakpoints).map(function (breakpoint) {
      if (props.hasOwnProperty(breakpoint)) {
        styles += makeColBreackpoint(props, breakpoint);
      }
    });
  } else {
    styles += makeSimpleCol();
  }

  return styles;
};